import React from "react";
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  Button,
} from "@mui/material";

export function ActionListFooter({
  grouped,
  onGroupedChange,
  openKey,
  openCount,
  completing,
  onComplete,
  onReportProblem,
}) {
  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        zIndex: 3,
        bgcolor: "background.paper",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        py: 1.5,
        gap: 1,
        // Subtle separator so the bar reads as floating above content
        borderTop: "0.5px solid",
        borderColor: "divider",
        // Negative top margin pulls the border flush against the table below
        mt: 0,
      }}
    >
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={grouped}
            onChange={(e) => onGroupedChange(e.target.checked)}
          />
        }
        label={
          <Typography variant="caption" color="text.secondary">
            Ryhmittely
          </Typography>
        }
        labelPlacement="end"
        sx={{ m: 0, gap: 0.5 }}
      />

      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        {openKey && (
          <Button
            size="small"
            variant="text"
            color="inherit"
            sx={{ fontSize: "0.75rem", color: "text.secondary" }}
            onClick={onReportProblem}
          >
            Ilmoita ongelma
          </Button>
        )}
        <Button
          size="medium"
          variant="outlined"
          disabled={!openKey || completing}
          onClick={onComplete}
          sx={{ fontSize: "0.875rem", fontWeight: 500, minWidth: 110 }}
        >
          {completing ? "Tallennetaan…" : (
            <>
              Suoritettu
              {openCount > 1 && (
                <Box
                  component="span"
                  sx={{
                    ml: 0.75,
                    px: 0.625,
                    py: 0.125,
                    borderRadius: 0.5,
                    bgcolor: "action.selected",
                    fontSize: "0.75rem",
                    fontWeight: 700,
                    verticalAlign: "middle",
                  }}
                >
                  {openCount}
                </Box>
              )}
            </>
          )}
        </Button>
      </Box>
    </Box>
  );
}